import { useState, useEffect } from 'react';
import axios from '../../axios-default';
import useAuth from '../../hooks/useAuth';
import { ROLE_NAMES } from '../../util/const';

const useOAuthPlatformConnected = (impressionType = undefined) => {
    const [threeshapeConnected, setThreeshapeConnected] = useState(false);
    const auth = useAuth();
    useEffect(() => {
        const checkThreeshapeConnected = async () => {
            const res = await axios.get('/threeshape/check_connect');
            let isConnected = false;
            if (res.status === 200 && res.data && res.data.success) {
                isConnected = true;
            }
            setThreeshapeConnected(isConnected);
        };
        if (impressionType && auth.user.role === ROLE_NAMES.doctor) {
            checkThreeshapeConnected();
        }
    }, [impressionType, auth.user.role]);

    return {
        threeshapeConnected,
        setThreeshapeConnected,
    };
};

export default useOAuthPlatformConnected;
